export default __webpack_public_path__ + "static/media/slider-whtie-arrow.ee687b33.svg";